import styled from 'styled-components';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const CheckBoxWrapper = styled.div`
  position: relative;
  display: flex;
`;
const CheckBoxLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 42px;
  height: 25px;
  border-radius: 15px;
  background: #bebebe;
  cursor: pointer;
  &::after {
    content: '';
    display: block;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    margin: 3px;
    background: #ffffff;
    box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
    transition: 0.2s;
  }
`;
const CheckBox = styled.input`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 42px !important;
  height: 26px !important;
  &:checked + ${CheckBoxLabel} {
    background: #002637;
    &::after {
      content: '';
      display: block;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      margin-left: 21px;
      transition: 0.2s;
    }
  }

  &:disabled + ${CheckBoxLabel} {
    background: #f2f2f2;
    cursor: not-allowed;

    &::after {
      background: #ccc;
    }
  }
`;

const Label = styled.label`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  text-transform: capitalize;
  line-height: 17px;
  /* identical to box height */

  display: flex;
  align-items: center;

  /* 1 */

  color: #1c1c1c;
  margin: 0 12px;
`;

const Checkbox = ({
  id = 'checkbox',
  label,
  assign = 'right',
  texts = {},
  ...rest
}) => {
  const { t } = useTranslation();
  const ref = useRef();
  const [checked, setChecked] = useState(false);
  const selectShortlistedApplicant = (e) => {
    const c = e.target.checked;
    if (c !== checked) {
      setChecked(c);
    }
  };
  const labelText = useMemo(() => {
    if (checked) {
      return texts?.checked || t('abilitata');
    }

    return texts?.unchecked || t('disabilitata');
  }, [checked, texts, t]);

  useEffect(() => {
    if (ref.current) {
      setChecked(ref.current?.checked);
    }
  }, [ref, texts]);

  return (
    <CheckBoxWrapper>
      <CheckBox
        id={id}
        ref={ref}
        type='checkbox'
        {...rest}
        onClick={(e) => {
          selectShortlistedApplicant(e);
        }}
      />
      <CheckBoxLabel htmlFor={id} />
      {assign === 'right' && <Label htmlFor={id}>{labelText}</Label>}
    </CheckBoxWrapper>
  );
};

export default Checkbox;
